'use client';

import React from 'react';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet-async';

export const PrivacyPolicy: React.FC = () => {
    const { t } = useTranslation();
    const logItems = t('privacy.section4.items', { returnObjects: true }) as string[];
    const processors = t('privacy.section10.items', { returnObjects: true }) as string[];
    const rights = t('privacy.section13.items', { returnObjects: true }) as string[];

    return (
        <div className="legal-page">
            <Helmet>
                <title>{t('privacy.title')}</title>
            </Helmet>
            <div className="container">
                <div className="legal-card">
                    <h1 className="legal-title">{t('privacy.title')}</h1>
                    <p className="legal-meta">{t('privacy.updated')}</p>

                    <section className="legal-section">
                        <h3>{t('privacy.section1.title')}</h3>
                        <p>{t('privacy.section1.body')}</p>
                        <p>{t('privacy.section1.body2')}</p>
                    </section>

                    <section className="legal-section">
                        <h3>{t('privacy.section2.title')}</h3>
                        <p>{t('privacy.section2.body')}</p>
                        <p>{t('privacy.section2.body2')}</p>
                    </section>

                    <section className="legal-section">
                        <h3>{t('privacy.section3.title')}</h3>
                        <p>{t('privacy.section3.body')}</p>
                        <p>{t('privacy.section3.body2')}</p>
                    </section>

                    <section className="legal-section">
                        <h3>{t('privacy.section4.title')}</h3>
                        <p>{t('privacy.section4.body')}</p>
                        <ul className="legal-list">
                            {logItems.map((item) => (
                                <li key={item}>{item}</li>
                            ))}
                        </ul>
                        <p>{t('privacy.section4.body2')}</p>
                        <p>{t('privacy.section4.body3')}</p>
                    </section>

                    <section className="legal-section">
                        <h3>{t('privacy.section5.title')}</h3>
                        <p>{t('privacy.section5.body')}</p>
                        <p>{t('privacy.section5.body2')}</p>
                    </section>

                    <section className="legal-section">
                        <h3>{t('privacy.section6.title')}</h3>
                        <p>{t('privacy.section6.body')}</p>
                        <p>{t('privacy.section6.body2')}</p>
                        <p>{t('privacy.section6.body3')}</p>
                    </section>

                    <section className="legal-section">
                        <h3>{t('privacy.section7.title')}</h3>
                        <p>{t('privacy.section7.body')}</p>
                        <p>{t('privacy.section7.body2')}</p>
                        <p>{t('privacy.section7.body3')}</p>
                        <p>{t('privacy.section7.body4')}</p>
                        <p>{t('privacy.section7.body5')}</p>
                        <p>{t('privacy.section7.body6')}</p>
                        <p>{t('privacy.section7.body7')}</p>
                    </section>

                    <section className="legal-section">
                        <h3>{t('privacy.section8.title')}</h3>
                        <p>{t('privacy.section8.body')}</p>
                        <p>{t('privacy.section8.body2')}</p>
                        <p>{t('privacy.section8.body3')}</p>
                        <p>{t('privacy.section8.body4')}</p>
                        <p>{t('privacy.section8.body5')}</p>
                        <p>{t('privacy.section8.body6')}</p>
                        <p>{t('privacy.section8.body7')}</p>
                    </section>

                    <section className="legal-section">
                        <h3>{t('privacy.section9.title')}</h3>
                        <p>{t('privacy.section9.body')}</p>
                        <p>{t('privacy.section9.body2')}</p>
                        <p>{t('privacy.section9.body3')}</p>
                        <p>{t('privacy.section9.body4')}</p>
                    </section>

                    <section className="legal-section">
                        <h3>{t('privacy.section10.title')}</h3>
                        <p>{t('privacy.section10.body')}</p>
                        <ul className="legal-list">
                            {processors.map((item) => (
                                <li key={item}>{item}</li>
                            ))}
                        </ul>
                    </section>

                    <section className="legal-section">
                        <h3>{t('privacy.section11.title')}</h3>
                        <p>{t('privacy.section11.body')}</p>
                    </section>

                    <section className="legal-section">
                        <h3>{t('privacy.section12.title')}</h3>
                        <p>{t('privacy.section12.body')}</p>
                    </section>

                    <section className="legal-section">
                        <h3>{t('privacy.section13.title')}</h3>
                        <p>{t('privacy.section13.body')}</p>
                        <ul className="legal-list">
                            {rights.map((item) => (
                                <li key={item}>{item}</li>
                            ))}
                        </ul>
                    </section>

                    <section className="legal-section">
                        <h3>{t('privacy.section14.title')}</h3>
                        <p>{t('privacy.section14.body')}</p>
                    </section>

                    <section className="legal-section">
                        <h3>{t('privacy.section15.title')}</h3>
                        <p>{t('privacy.section15.body')}</p>
                        <p>{t('privacy.section15.body2')}</p>
                    </section>

                    <section className="legal-section">
                        <h3>{t('privacy.section16.title')}</h3>
                        <p>{t('privacy.section16.body')}</p>
                    </section>

                    <section className="legal-section">
                        <h3>{t('privacy.section17.title')}</h3>
                        <p>{t('privacy.section17.body')}</p>
                    </section>
                </div>
            </div>
        </div>
    );
};
